import { Box, StyleSystemProps, styled } from '@withjoy/joykit';

export const StyledAddressDialogContent = styled(Box)``;
const addressDialogContentStyles: StyleSystemProps = {
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%)',
  width: '100%',
};

export const styles = {
  addressDialogContent: addressDialogContentStyles,
};
